import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { ITecnicaAuditoriaModel } from '../models/tecnica-auditoria.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class TecnicaAuditoriaService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(pesquisa: string, ativo: boolean, simplificado = false): Promise<IBaseModel<ITecnicaAuditoriaModel[]>> {
    let params = new HttpParams();
    params = params.append('pesquisa', pesquisa || '');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<ITecnicaAuditoriaModel[]>>(`${this.apiBaseUrl}/tecnicaauditoria`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<ITecnicaAuditoriaModel>> {
    return this.httpClient
      .get<IBaseModel<ITecnicaAuditoriaModel>>(`${this.apiBaseUrl}/tecnicaauditoria/${id}`)
      .toPromise();
  }

  public async inserir(data: ITecnicaAuditoriaModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/tecnicaauditoria`, data)
      .toPromise();
  }

  public async atualizar(data: ITecnicaAuditoriaModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/tecnicaauditoria/${data.id}`, data)
      .toPromise();
  }

  public async reativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/tecnicaauditoria/${id}/reativar`, {})
      .toPromise();
  }

  public async inativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/tecnicaauditoria/${id}/inativar`, {})
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/tecnicaauditoria/${id}`, {})
      .toPromise();
  }
}
